import cx from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IMapLayerProps extends React.ComponentPropsWithoutRef<'div'> {}

export function MapLayer(props: IMapLayerProps) {
  return <div {...props} className={cx(props.className, styles['layer'])} />;
}
